import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_PROJECT,
  SET_PROJECTS,
  SET_NEW_PROJECT_ID,
} from 'store/actions/projects';
import { addIdPrefix } from 'services/common';

const initialState = {
  projects: [],
  newProjectId: -1,
  isFetching: false,
  error: '',
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setProject = (state, { project }) =>
  state.merge({
    projects: state.projects.map(p => (p.id === project.id ? project : p)),
  });

const setProjects = (state, { projects }) => state.merge({ projects });

const setNewProjectId = (state, { newProjectId }) =>
  state.merge({ newProjectId });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_PROJECT]: setProject,
  [SET_PROJECTS]: setProjects,
  [SET_NEW_PROJECT_ID]: setNewProjectId,
};

export default createReducer(initialState, handlers);
